import { render, staticRenderFns } from "./FormKasbonExternal.vue?vue&type=template&id=730e927c"
import script from "./FormKasbonExternal.vue?vue&type=script&lang=js"
export * from "./FormKasbonExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports